import EMPTY_FIELD_VALUE from '../../config/defaultValues';

export const creativeSizeFormatter = ({ value }) => {
    const [dimension] = value ?? [];
    if (!dimension) {
        return EMPTY_FIELD_VALUE;
    }

    const { width, height } = dimension;

    return `${width} x ${height}`;
};
